import { Tabs } from '../../modules/tabs.js';

window.app = window.app || {};
app.ui = app.ui || {};


app.ui.tabs = () => {
    document.querySelectorAll('.tabs').forEach(tab => {
        new Tabs({
            tabs: tab,
            allowDeeplinking: true,
            on: {
                change: (c, n) => app.site.controls.stop(c)
            }
        });
    });
};
